import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import socketIOClient from "socket.io-client";
import { UserContext } from "./user.context";
import { PrinterContext } from "./printer.context";
import { getDataUser, getIsValidTable, getClosedStatus } from "../components/user/getDataUser";

const useReservation = () => {
  let { ownerId, tableId } = useParams();
  ownerId = ownerId && ownerId !== "undefined" ? decodeURIComponent(ownerId) : undefined;
  tableId = tableId && tableId !== "undefined" ? decodeURIComponent(tableId) : undefined;
  const [dishes, setDishes] = useState(
    sessionStorage.getItem("reservationDishes")
      ? JSON.parse(sessionStorage.getItem("reservationDishes"))
      : []
  );
  const [categories, setCategories] = useState([]);
  const [versionApp, setVersionApp] = useState(0);
  const [isValidTable, setIsValidTable] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [messaggioChiusura, setMessaggioChiusura] = useState('');
  const [error, setError] = useState(false);
  const [ownerIdValid, setownerIdValid] = useState(false);
  const [successOrder, setSuccessOrder] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userHistory, setUserHistory] = useState([]);
  //const [connected, setConnected] = useState(false);
  const [socket, setSocket] = useState(null);
  const [cart, setCart] = useState(
    sessionStorage.getItem("cart")
      ? JSON.parse(sessionStorage.getItem("cart"))
      : []
  );
  const { user } = useContext(UserContext);
  const { printCurrentCartOnly, errorOccurred, sendOrderToPrinter_R_C } = useContext(PrinterContext);
  const history = useHistory();
  // verify businessId
  useEffect(() => {
    if (!ownerId || ownerId === "undefined") {
      return;
    }

    setError(false);
    let subscribed = true;

    axios.post("/api/reservation/verify/businessId", { businessId: ownerId })
      .then(({ data }) => {
        if (!subscribed) return;
        setownerIdValid(data.success);
        if (!data.success) setError("business_id_error");
      })
      .catch(err => {
        if (!subscribed) return;
        console.error("[Reservation] verify businessId error", err);
        setError(true);
      });

    return () => (subscribed = false);
  }, [ownerId]);


  //con la speranza che non ha sputtanato il lato owner
  useEffect(() => {
    if (user.type === 'user') {
      const s = socketIOClient(process.env.REACT_APP_SERVER_URL, {
        secure: true,
        transports: ['websocket'],
        query: { ownerId, type: 'user', tableId }, //ogni volta che aggiunge una socket devi mettere ownerId critptato
      });
      setSocket(s);
    }
    if (user.type === 'owner') {
      const s = socketIOClient(process.env.REACT_APP_SERVER_URL, {
        secure: true,
        transports: ["websocket"],
        query: { ownerId: user.id },
      });
      setSocket(s);
    }// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerId]);


  useEffect(() => {
    if (socket) {
      socket.on("connect", () => {
        //setConnected(true);
      });
      socket.on("disconnect", () => {
        //setConnected(false);
      });
      socket.on("order", order);
      socket.on("eraseOrder", eraseOrder);
      socket.on("fetchUserHistory", fetchUserHistory);
      return () => {
        socket.off("order");
        socket.off("eraseOrder");
        socket.off("connect");
        socket.off("disconnect");
        socket.off("fetchUserHistory");
      };
    }// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, isLoading, successOrder]);

  // fetchAll: dati utente + stato tavolo
  useEffect(() => {
    // Se ownerId o tableId sono mancanti o letteralmente "undefined", esci
    if (!ownerId || ownerId === "undefined") return;

    let isMounted = true;
    const fetchAll = async () => {
      try {
        const promises = [getDataUser(ownerId)];

        if (tableId && tableId !== 'undefined') {
          // Tavolo specifico
          promises.push(getIsValidTable(ownerId, tableId));
        } else {
          // Nessun tavolo
          promises.push(getClosedStatus(ownerId));
        }

        const results = await Promise.all(promises);
        if (!isMounted) return;

        if (tableId && tableId !== 'undefined') {
          const [version, validTable] = results;
          setVersionApp(version);
          setIsValidTable(validTable.success);
        } else {
          const [version, closedStatus] = results;
          setVersionApp(version);
          setIsValidTable(false);
          setIsClosed(closedStatus.isClosed);
          setMessaggioChiusura(closedStatus.messaggio);
        }

      } catch (err) {
        console.error("[Reservation] fetchAll error", err);
      }
    };

    fetchAll();
    return () => { isMounted = false; };
  }, [ownerId, tableId]);


  //get owner menu data
  useEffect(() => {
    if (ownerId && dishes.length <= 0 && ownerIdValid) {
      setError(false);
      let subscribed = true;
      axios
        .post("/api/menu/user/get", { businessId: ownerId })
        .then(({ data }) => {
          if (subscribed) {
            if (data.success) {
              setDishes(data.data);
            } else {
              setError("dish_error");
            }
          }
        });
      return () => (subscribed = false);
    }// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerId, ownerIdValid, history.location.pathname]);

  //get categories from dishes list
  useEffect(() => {
    const c = [];
    dishes.forEach(({ categoryId, categoryName, icon_key }) => {
      const catId = c.map(({ id }) => id);
      if (catId.indexOf(categoryId) === -1) {
        c.push({
          id: categoryId,
          name: categoryName,
          icon_key: icon_key || null
        });
      }
    });
    setCategories(c);

    // if (dishes && dishes.length > 0) {
    //   sessionStorage.setItem("reservationDishes", JSON.stringify(dishes));
    // }
    setIsLoading(false);
  }, [dishes]);


  const fetchUserHistory = async () => {
    if (!tableId || tableId === 'undefined') {
      return;
    }
    try {
      const { data } = await axios.post("/api/history/user/get", { tableId, ownerId, socketId: socket?.id || null });
      if (data.success) {
        setUserHistory(data.history);
      } else setError(true);
    } catch (err) {
      setError(true);
    }
  };



  const mergeDuplicateItems = cart => {
    const groupedItems = {};

    cart.forEach((item) => {
      const key = JSON.stringify({
        categoryId: item.categoryId,
        id: item.id,
        variants: item.variants,
        note: item.note,
        nome: item.name,
        selected: item.selected_option
      });


      if (groupedItems[key]) {
        groupedItems[key].amount += item.amount;
      } else {
        groupedItems[key] = { ...item };
      }
    });

    const mergedCart = Object.values(groupedItems);
    return mergedCart;
  }




  //set cart in session storage
  useEffect(() => {
    if (cart && cart.length > 0) {
      sessionStorage.setItem("cart", JSON.stringify(mergeDuplicateItems(cart)));
    }
  }, [cart]);


  const getSocketId = () => (socket ? socket.id : null);

  // lazy fetchHistory get user history onload
  useEffect(() => {
    if (!ownerId || !tableId || tableId === 'undefined') return;
    const timeout = setTimeout(fetchUserHistory, 2000);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerId, tableId, successOrder]);

  // MODIFICATO: Gestione della stampa integrata con il carrello corrente
  const order = (obj) => {
    setSuccessOrder(true);
    setError(false);

    const finalTableId = tableId || obj?.tableId;
    const finalOwnerId = ownerId || obj?.ownerId;
    const isOwner = !!obj; // esplicito 
    // Alleviamo una copia esatta del carrello corrente prima dell'azzeramento dello storage
    const cartToPrint = [...cart];

    axios.post("/api/reservation/user/order", {
      cart: cart.filter(({ amount }) => amount > 0),
      tableId: finalTableId,
      ownerId: finalOwnerId,
      isOwner,
      socketId: getSocketId()
    })
      .then(({ data }) => {
        if (data.success) {
          setSuccessOrder(false);

          // Eseguiamo la stampa istantanea solo se l'ordine proviene dall'owner
          if (isOwner && !errorOccurred) {
            printCurrentCartOnly(finalTableId, cartToPrint);
          }

          sessionStorage.removeItem("reservationDishes");
          sessionStorage.removeItem("cart");
        } else {
          setError(true);
        }
      });
  };

  const orderRoomCart = (obj) => {
    // obj.deliveryId, obj.ownerId
    setSuccessOrder(true);
    setError(false);
    axios
      .post("/api/reservation/user/orderRoomCart", {
        cart: cart.filter(({ amount }) => amount > 0),
        deliveryId: obj.deliveryId,
        ownerId: obj.ownerId,
        userId: obj.userId,
        socketId: getSocketId()
      })
      .then(({ data }) => {
        if (data.success) {
          setSuccessOrder(false);
          sessionStorage.removeItem("reservationDishes");
          sessionStorage.removeItem("cart");
          //mettere eventuale stampa ordine per consegna
          if (!errorOccurred) sendOrderToPrinter_R_C(obj.deliveryId);
        } else {
          setError(true);
        }
      });
  }

  const eraseOrder = () => {
    setSuccessOrder(false);
    setError(false);
    setCart([]);
  };

  const addToCart = (dish) => {
    setCart((c) => {
      let cartNew = [...c, dish];
      return mergeDuplicateItems(cartNew)
    });
  };

  const changeAmount = (index, newAmount) => {
    let c = [...cart];
    if (newAmount === 0) {
      removeFromCart(index);
      return;
    }
    c[index].amount = newAmount;
    setCart(c);
  };

  const removeFromCart = (index) => {
    setCart((c) => {
      c = c.filter((_, i) => i !== index);
      sessionStorage.setItem("cart", JSON.stringify(c));
      return c;
    });
  };

  const setDishNote = (index, text) => {
    let c = [...cart];
    c[index] = { ...c[index], note: text };
    setCart(c);
  };

  const getDishPrice = (dish) => {
    let sum = dish.price;
    if (dish.variants) {
      for (let x of dish.variants) {
        if (Array.isArray(x.selected)) {
          for (let y of x.selected) {
            sum += y.price;
          }
        } else {
          sum += x.selected.price;
        }
      }
    }
    return sum;
  };

  const updateDishPrice = (index, delta) => {
    setCart((prevCart) => {
      const updatedCart = [...prevCart];
      if (updatedCart[index]) {
        const currentPrice = updatedCart[index].price || 0;
        updatedCart[index] = { ...updatedCart[index], price: Math.max(0, currentPrice + delta) };
      }
      return updatedCart;
    });
  };


  const getTotalPrice = () => {
    return cart
      .filter(({ amount }) => amount > 0)
      .reduce((acc, dish) => acc + getDishPrice(dish) * dish.amount, 0);
  }

  const updateDishVariants = (dishIndex, newVariants) => {
    setCart(prevCart => {
      const updatedCart = [...prevCart];
      updatedCart[dishIndex] = {
        ...updatedCart[dishIndex],
        variants: newVariants,
      };
      return updatedCart;
    });
  };


  return {
    dishes,
    categories,
    addToCart,
    setDishes,
    order,
    getTotalPrice,
    error,
    successOrder,
    isLoading,
    eraseOrder,
    userHistory,
    setUserHistory,
    tableId,
    ownerId,
    setSocket,
    getDishPrice,
    cart,
    setCart,
    changeAmount,
    removeFromCart,
    setDishNote,
    orderRoomCart,
    versionApp,
    isValidTable,
    isClosed,
    messaggioChiusura,
    updateDishPrice,
    updateDishVariants
  };
};

export const ReservationContext = createContext();

export const ReservationProvider = (props) => {
  const reservation = useReservation();

  return (
    <>
      <ReservationContext.Provider value={reservation}>
        {props.children}
      </ReservationContext.Provider>
    </>
  );
};
